import React from "react";
import { GeneralButton } from "./style";

export default function Button({ text, disabled, display, displayMobile, type, width }) {
  return (
    <GeneralButton disabled={disabled} display={ display } displayMobile={ displayMobile } type={type} width={width}>
      { text }
    </GeneralButton>
  )
}